import React, { useEffect, useMemo, useState } from 'react';
import { Card, Grid, Icon, Table, Typography } from 'antd';
import moment from 'moment';
import { apiGetReturnCmd } from '@services/ManageDevices/DeviceServices';

export default function List() {
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalItems, setTotalItems] = useState(0);

  const fetchReturnCmd = async () => {
    try {
      const res = await apiGetReturnCmd({ page: currentPage, size: pageSize });
      setData(res.data?.data);
      setTotalItems(res.data?.meta?.total);
    } catch (err) {
      console.log(err);
    }
  };

  const handleChangePage = (page) => {
    setCurrentPage(page);
  };

  const handleChangePageSize = (current, size) => {
    setPageSize(size);
    setCurrentPage(1);
  };

  useEffect(() => {
    fetchReturnCmd();
  }, [currentPage, pageSize]);

  const columns = useMemo(
    () => [
      {
        title: 'ID',
        dataIndex: 'id',
        key: 'id',
        width: 60
      },
      {
        title: 'Serial Number',
        dataIndex: 'serial_no',
        key: 'serial_no',
        width: 120
      },
      {
        title: 'IMEI',
        dataIndex: 'IMEI',
        key: 'IMEI',
        width: 120
      },
      {
        title: 'Created at',
        dataIndex: 'created_at',
        key: 'created_at',
        render: (text) => <div>{text ? moment(text).format('DD/MM/YYYY HH:mm') : '-'}</div>
      },
      {
        title: 'Meter Reading (L)',
        dataIndex: 'meterReading',
        key: 'meterReading'
      },
      {
        title: 'RSRP (dBm)',
        dataIndex: 'rsrp',
        key: 'rsrp',
        render: (text) => <div>{text / 10}</div>
      },
      {
        title: 'SNR (dB)',
        dataIndex: 'snr',
        key: 'snr',
        render: (text) => <div>{text / 10}</div>
      },
      {
        title: 'Voltage (V)',
        dataIndex: 'voltage',
        key: 'voltage',
        render: (text) => <div>{text / 100.0}</div>
      },
      {
        title: 'Report period (min)',
        dataIndex: 'report_period',
        key: 'report_period',
        render: (text) => <div>{text / 60}</div>
      },
      {
        title: 'Pulse constant (L/P)',
        dataIndex: 'pulse_constant',
        key: 'pulse_constant',
        render: (text) => {
          switch (text) {
            case '0':
              return <div>Direct reading meter</div>;
            case '1':
              return <div>1</div>;
            case '2':
              return <div>10</div>;
            case '3':
              return <div>100</div>;
            case '4':
              return <div>1000</div>;
            default:
              return <div>-</div>;
          }
        }
      },
      {
        title: 'Valve Status',
        dataIndex: 'valve_status',
        key: 'valve_status',
        render: (text) => {
          switch (text) {
            case '0':
              return <div>Open</div>;
            case '1':
              return <div>Close</div>;
            case '3':
              return <div>Is moving</div>;
            default:
              return <div>-</div>;
          }
        }
      },
      {
        title: 'Abnormal alarm',
        key: 'abnormal_alarm',
        render: (text, record) => <div>{record['/82/0']}</div>
      }
    ],
    []
  );

  return (
    <div>
      <Typography.Title level={4}>Return command</Typography.Title>
      <Card bordered={false}>
        <Table
          bordered
          // size="middle"
          dataSource={data || []}
          columns={columns}
          pagination={{
            current: currentPage,
            pageSize: pageSize,
            total: totalItems,
            showSizeChanger: true,
            onChange: handleChangePage,
            onShowSizeChange: handleChangePageSize,
            showTotal: (total, range) => `${range[0]}-${range[1]} của ${total} bản ghi`
          }}
          style={{
            borderRadius: 8,
            thead: { backgroundColor: '#e2e8f0', color: '#64748b' }
          }}
          scroll={{ x: 'max-content' }}
        />
      </Card>
    </div>
  );
}
